import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=18bb02a2&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Main.vue?vue&type=style&index=1&id=18bb02a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb02a2",
  null
  
)

export default component.exports